import React, { useState, useEffect } from "react";
import { UserAddOutlined, FilePdfOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Input,
    Modal,
    Row,
} from "antd";
import { AlumnoFields, AlumnoForm } from "./AlumnoForm";
import InvoiceTicket from "./InvoiceTicket";
import { DownloadDocumentButton, PostInvoiceButton } from "../../common/components";
import db from "../../../../db/database";
import { syncInvoiceToBC, getFinalDocumentNo } from "../../../../services/invoiceSyncService";
import { downloadInvoicePdfFromBC, fetchFromBusinessCentral } from "../../../../utils/businessCentralUtils";


//************************************ InvoiceForm.js methods ************************************
/**
 * Validacion para mostrar modal de confirmación de datos del cliente
 */
export const useConfirmationModal = (props) => {
    const { lines } = props;

    if (!lines) {
        return false;
    }

    const totalUnitPrice = lines.reduce((sum, line) => sum + ((line.Unit_Price || 0) * line.Quantity), 0);

    return totalUnitPrice >= 10000;
};

export const handleInvoiceSubmitByCountry = async (props) => {
    debugger
    const { invoice, country, setLoading } = props;

    try {
        await db.invoices.update(invoice.id, {
            syncing: true,
            syncStartTime: new Date().toISOString()
        });

        window.messageApi.info("Sincronizando factura...");

        const result = await syncInvoiceToBC(invoice, country);

        const updatedInvoice = await db.invoices.get(invoice.id);

        const isPosted =
            updatedInvoice?.syncStage === "posted" &&
            updatedInvoice?.posted === 1;

        //Si contabilizo debemos obtener No final de factura y NCF para imprimir ticket
        if (result.success && isPosted) {
            const finalDoc = await getFinalDocumentNo(updatedInvoice);
            updatedInvoice = await db.invoices.get(invoice.id);

            if (updatedInvoice?.No_Serie_NCF_Facturas) {
                const serie = await fetchFromBusinessCentral(`NoSeriesLines?$filter= Series_Code eq '${updatedInvoice?.No_Serie_NCF_Facturas}'`)
            }

            window.messageApi.success("Factura sincronizada correctamente");
        } else {
            window.messageApi.error(`Error al contabilizar: ${result.message}`, { modal: true });
        }
    } catch (error) {
        console.error("Error al sincronizar factura:", error);
        window.messageApi.error("No se pudo sincronizar la factura");
    } finally {
        // Limpiar marca de sincronizando
        await db.invoices.update(invoice.id, {
            syncing: false,
            syncStartTime: null
        });
        setLoading(false);
    }
};

//************************************InvoiceForm.js slots************************************
/**
 * COMPONENTE SLOT PARA LA SECCIÓN "CLIENTE"
 * Se renderizará dentro del Card de Cliente en el formulario principal.
 */
export const ClientSection = ({ invoiceData, active }) => {
    const [visible, setVisible] = useState(false);

    //abrir modal si es honduras y falta un dato
    useEffect(() => {
        if (active) {
            setVisible(true);
        }
    }, [active, invoiceData]);

    return (
        <Row gutter={16}>
            <Col span={20}>
                <Form.Item
                    name="Sell_to_Customer_Name_2"
                    label="Alumno"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col
                span={4}
                style={{
                    display: "flex",
                    alignItems: "end",
                    paddingBottom: "24px",
                }}
            >
                <Button
                    type="primary"
                    icon={<UserAddOutlined />}
                    onClick={() => setVisible(true)}
                    title="Añadir alumno"
                    style={{ width: "100%" }}
                />
            </Col>

            <Modal
                title="Datos fiscales cliente"
                open={visible}
                onOk={() => setVisible(false)}
                onCancel={() => setVisible(false)}
            >
                <AlumnoFields isRequired={false} />
            </Modal>
        </Row>
    );
};

/**
 * COMPONENTE SLOT PARA LA SECCIÓN "CONFIRMACION"
 * Se renderizará en onSubmit de la nueva factura para corroborar datos de facturacion
 */
export const ConfirmationFormSection = ({ handleSubmit, handleCancel, initialData }) => {
    return (
        <div className="confirmation-modal-content">

            <p className="legal-notice">
                Por requisitos legales, es necesario ingresar y confirmar todos los datos del alumno cuando el monto total es igual o superior a L 10.000.
            </p>

            <AlumnoForm isRequired={true} handleSubmit={handleSubmit} handleCancel={handleCancel} initialData={initialData} />
        </div>
    )
}

/**
 * COMPONENTE SLOT PARA LA SECCIÓN "TICKET"
 * Se renderizará al confirmar factura.
 */
export const TicketSection = (props) => (
    <InvoiceTicket {...props} />
);


//************************************InvoiceList.js methods************************************
const handleHondurasInvoiceDownload = async (invoice, setLoading) => {
    if (!invoice?.systemId) {
        window.messageApi.error("La factura aún no está contabilizada.");
        return;
    }

    try {
        setLoading(true);

        await downloadInvoicePdfFromBC({
            invoiceSystemId: invoice.systemId,
            fileName: `Factura_${invoice.No}.pdf`,
        });
    } finally {
        setLoading(false);
    }
};

//************************************InvoiceList.js slots************************************
export const DownloadTicketButton = (props) => { return null; }

export const DownloadInvoiceButton = (props) => {
    return (
        <DownloadDocumentButton
            {...props}
            icon={<FilePdfOutlined />}
            title="Descargar factura"
            onDownload={handleHondurasInvoiceDownload}
        />
    );
};

export { PostInvoiceButton };